import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapState, mapGetters, mapActions } from 'vuex'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
})

const vue = new Vue({
  el: '#vue',
  store,
  data: () => ({}),
  computed: {},
  methods: {},
  watch: {},
  created() {},
  mounted() {},
})